/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Text, theme } from "@nordcloud/gnui";
import {
  ReservationsAndCommitmentsCoverageServiceUsageType,
  ReservationsProvider,
} from "~/generated/graphql";
import { dateFormat } from "~/constants";
import { useGetTooltipData } from "../hooks";
import { ReservationTooltipActualCost } from "./ReservationsCommitmentsTooltip/ReservationTooltipActualCost";

type Props = {
  date: string;
  totalCost: string;
  reservedInstanceCost: string;
  savingsPlanCost: string;
  onDemandCost: string;
  serviceUsageType: ReservationsAndCommitmentsCoverageServiceUsageType;
  provider: ReservationsProvider;
};

export function UsageTooltip({
  date,
  totalCost,
  reservedInstanceCost,
  savingsPlanCost,
  onDemandCost,
  serviceUsageType,
  provider,
}: Props) {
  const tooltipOnGraph = useGetTooltipData({
    serviceUsageType,
    savingsPlanCost: Number(savingsPlanCost),
    reservedInstanceCost: Number(reservedInstanceCost),
    onDemandCost: Number(onDemandCost),
    totalCost: Number(totalCost),
    provider,
  });

  return (
    <>
      <Text size="sm" mb="0" color={theme.color.text.text04}>
        {dayjs(date).format(dateFormat.dayShortMonthYear)}
      </Text>
      <ReservationTooltipActualCost values={tooltipOnGraph} />
    </>
  );
}
